import { Tabs, Table } from 'antd';
import { useLocation } from 'react-router-dom';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { isProxy } from 'datastake-daf/src/helpers/Token';
import { openDSWindow } from '../../../../helpers/Window';
import { getLocales } from '../../../../components/Table/newTable';

const Style = styled.div`
  margin-top: -16px;
  width: 100%;
`;

const { TabPane } = Tabs;

const modeIsProxy = isProxy();

const links = {
  mineSite: (mod, id) => `/app/${mod}/analysis/scl/${id}`,
  village: (mod, id) => `/app/${mod}/view/village/${id}`,
  default: (mod, id) => `/app/${mod}/view/location/${id}`,
};

const proxyLinks = {
  mineSite: (mod, id) => `/proxy/${mod}/analysis/scl/${id}`,
  village: (mod, id) => `/proxy/${mod}/view/village/${id}`,
  default: (mod, id) => `/proxy/${mod}/view/location/${id}`,
};

export const getOptionLabel = (val = '', options = []) => {
  const item = options.find((o) => o.value === val);

  if (item && item.label) {
    return item.label;
  }

  return val;
}

const columns = (mod, options = {}) => [
  {
    title: "ID",
    dataIndex: 'datastakeId',
    key: 'datastakeId',
    render: (value, all) => {
      const cat = all.category;
      const linkFunc = links[cat] || links.default;

      if (modeIsProxy) {
        const proxyLinkFunc = proxyLinks[cat] || proxyLinks.default;

        return (
          <span
            style={{ color: 'var(--mmt-primary-70)', cursor: 'pointer' }}
            onClick={() => {
              openDSWindow({
                url: proxyLinkFunc('pme', value),
                name: `Datastake Location ${value}`,
              })
            }}
          >
            {value}
          </span>
        );
      }

      return (
        <Link
          to={linkFunc(mod, value)}
          target="_blank"
          rel="noreferrer"
        >
          {value}
        </Link>
      )
    },
  },
  {
    title: "Type",
    dataIndex: 'category',
    key: 'category',
    render: (val) => {
      const value = getOptionLabel(val, options ? options.locationCategoryOptions || [] : []);
      return value;
    },
  },
  {
    title: "Name",
    dataIndex: 'locationName',
    key: 'locationName',
  },
  {
    title: "Country",
    dataIndex: 'country',
    key: 'country',
    render: (val) => {
      const value = getOptionLabel(val, options ? options.countries || [] : []);
      return value;
    },
  },
]

const groupData = (data = [], linkingData) => {
  const conf = { mineSites: [], other: [] };

  if (Array.isArray(data)) {
    data.forEach((d) => {
      const subj = linkingData[d.locationId] ? linkingData[d.locationId] : d;
      if (subj.category === 'mineSite') {
        conf.mineSites.push(subj);
      } else {
        conf.other.push(subj);
      }
    });
  }

  return conf;
};

const DocumentsLocations = ({
  data = [],
  linkingData = {},
  viewConfig = {},
  allData = {},
}) => {
  const grouped = groupData(data, linkingData.SCL || {});
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const [, mod] = useMemo(() => isProxy() ?
    pathname.split(/\/proxy\/(pme|cadd)\/view/)
    : pathname.split(/\/app\/(pme|cadd)\/view/)
    , [pathname]);

  const cols = useMemo(() => columns(mod, viewConfig), [mod, viewConfig]);

  return allData.type === 'picture' ? (
    <Style>
      <Table
        locale={getLocales(t)}
        columns={cols}
        dataSource={[...grouped.mineSites, ...grouped.other]}
        pagination={false}
        size="small"
      />
    </Style>
  ) : (
    <Style>
      <Tabs
        defaultActiveKey="mineSite"
      >
        <TabPane key="mineSite" tab={`${t('Mine Sites')} (${grouped.mineSites.length})`}>
          <Table
            locale={getLocales(t)}
            columns={cols}
            dataSource={grouped.mineSites}
            pagination={false}
            size="small"
          />
        </TabPane>
        <TabPane key="other" tab={`${t('Other')} (${grouped.other.length})`}>
          <Table
            locale={getLocales(t)}
            columns={cols}
            dataSource={grouped.other}
            size="small"
            pagination={false}
          />
        </TabPane>
      </Tabs>

    </Style>
  )
}

export default DocumentsLocations;
